export interface ContactFormFields {
  name: string;
  plate: string;
  phone: string;
  email: string;
  message: string;
  'bot-field'?: string;
}

export async function submitNetlifyContact(
  fields: ContactFormFields,
): Promise<void> {
  const body = new URLSearchParams({
    'form-name': 'contact',
    name: fields.name,
    plate: fields.plate,
    phone: fields.phone,
    email: fields.email,
    message: fields.message,
    'bot-field': fields['bot-field'] ?? '',
  });

  const res = await fetch('/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body,
  });

  if (!res.ok) throw new Error('form_submit_failed');
}
